import { render } from "./CTAImageModule.vue?vue&type=template&id=38a61ff0&scoped=true"
import script from "./CTAImageModule.vue?vue&type=script&lang=js"
export * from "./CTAImageModule.vue?vue&type=script&lang=js"

import "./CTAImageModule.vue?vue&type=style&index=0&id=38a61ff0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a61ff0"]])

export default __exports__